import { AlignCenter, AlignLeft, AlignRight, Sparkles, Type } from "lucide-react";
import { useState } from "react";

export const COLORS = { preto: "#0F172A", azul: "#0A7CFF", laranja: "#F97316", verde: "#059669", rosa: "#DB2777" };

export const applyCommand = (cmd, el) => {
  const c = cmd.toLowerCase();
  const next = { ...el };
  Object.entries(COLORS).forEach(([n, hex]) => { if (c.includes(n)) next.color = hex; });
  if (c.includes("maior") || c.includes("grande")) next.size = Math.min(72, el.size + 10);
  if (c.includes("menor") || c.includes("pequen")) next.size = Math.max(14, el.size - 8);
  if (c.includes("centraliz") || c.includes("centro")) next.align = "center";
  if (c.includes("esquerda")) next.align = "left";
  if (c.includes("direita")) next.align = "right";
  return next;
};

export const DemoInspector = ({ el, onChange, label }) => {
  const [cmd, setCmd] = useState("");
  const [thinking, setThinking] = useState(false);
  const run = (e) => {
    e.preventDefault();
    if (!cmd.trim()) return;
    setThinking(true);
    setTimeout(() => { onChange(applyCommand(cmd, el)); setThinking(false); setCmd(""); }, 600);
  };
  return (
    <aside data-testid="demo-inspector" className="w-full lg:w-64 shrink-0 bg-white border-l border-slate-100 p-5 flex flex-col gap-6 text-sm">
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">Selecionado</div>
        <div className="mt-1 font-semibold text-[var(--ink)] flex items-center gap-2"><Type size={14} className="text-[var(--blue)]" /> {label}</div>
      </div>
      <div>
        <div className="flex justify-between text-slate-500 mb-2"><span>Tamanho</span><span className="font-mono text-[var(--ink)]">{el.size}px</span></div>
        <input data-testid="demo-size-slider" type="range" min="14" max="72" value={el.size} onChange={(e) => onChange({ ...el, size: +e.target.value })} className="w-full accent-[var(--blue)]" />
      </div>
      <div>
        <div className="text-slate-500 mb-2">Cor</div>
        <div className="flex gap-2">
          {Object.entries(COLORS).map(([n, hex]) => (
            <button key={n} data-testid={`demo-color-${n}`} aria-label={n} onClick={() => onChange({ ...el, color: hex })} style={{ background: hex }} className={`h-7 w-7 rounded-full border-2 transition-transform hover:scale-110 ${el.color === hex ? "border-[var(--ink)] scale-110" : "border-white shadow"}`} />
          ))}
        </div>
      </div>
      <div>
        <div className="text-slate-500 mb-2">Alinhamento</div>
        <div className="grid grid-cols-3 gap-1 rounded-xl bg-slate-100 p-1">
          {[["left", AlignLeft], ["center", AlignCenter], ["right", AlignRight]].map(([a, Icon]) => (
            <button key={a} data-testid={`demo-align-${a}`} onClick={() => onChange({ ...el, align: a })} className={`h-8 rounded-lg grid place-items-center transition-colors ${el.align === a ? "bg-white text-[var(--blue)] shadow-sm" : "text-slate-500 hover:text-[var(--ink)]"}`}><Icon size={15} /></button>
          ))}
        </div>
      </div>
      <form onSubmit={run} className="mt-auto rounded-2xl bg-[var(--ink)] p-3 text-white">
        <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400"><Sparkles size={12} className="text-[var(--orange)]" /> Pede pro Low</div>
        <input data-testid="demo-low-input" value={cmd} onChange={(e) => setCmd(e.target.value)} placeholder='ex: "deixa laranja e maior"' className="mt-2 w-full bg-white/10 rounded-lg px-3 py-2 text-xs placeholder:text-slate-500 outline-none focus:ring-2 ring-[var(--blue)]" />
        <button data-testid="demo-low-submit" disabled={thinking} className="mt-2 w-full rounded-lg bg-[var(--blue)] hover:bg-white hover:text-[var(--ink)] transition-colors py-2 text-xs font-semibold disabled:opacity-60">
          {thinking ? "Low pensando…" : "Aplicar"}
        </button>
      </form>
    </aside>
  );
};
